<app-profile-settings-tab-display #profileSelectorContainer
  [profiles]="filterProfiles$ | async"
  [appliedProfile]="currentFilterProfile$ | async"
  [selectedProfile]="currentEditingFilterProfile"
  [config]="filterProfileConfig"
  [loading]="loading"
  (editProfileClicked)="onEditingProfile($event)"
  (createProfileClicked)="onCreateNewProfile()"
  (applyProfileClicked)="onApplyProfile($event)"
  (copyProfileClicked)="onCopyProfile($event)"
  (deleteProfileClicked)="onDeleteProfile($event)"
  (cancelProfileClicked)="filterProfileSettings.cancel()"
  (saveProfileClicked)="filterProfileSettings.save()"
  (resetProfileClicked)="filterProfileSettings.reset()" 
  [disableSave]="filterProfileSettings.disableSave"
  [formGroup]="currentfilterProfileFormGroup"
>
  <div header-container>
    <h3 *ngIf="!editingName" class="m-0 flex items-center gap-1 text-xl font-semibold">
      {{ currentEditingFilterProfile?.filterProfileName }}
      <button mat-icon-button (click)="onEditProfileNameClicked()" *ngIf="!currentEditingFilterProfile?.isReadOnly">
        <mat-icon>edit</mat-icon>
      </button>
    </h3>
    <h3 *ngIf="editingName" class="profile-name-edit-container m-0">
      <app-form-field
        [formGroup]="currentfilterProfileFormGroup"
        [fieldControlName]="'filterProfileName'"
        [type]="'text'"
        formControlStyle="underline"
        [appearance]="'standard'"
        [formState]="currentEditingFilterProfile$ | async"
        #filterProfileNameField
        [errorText]="getFilterProfileNameError()"
        [col]="8"
      ></app-form-field>
      <button mat-icon-button (click)="onCancelProfileNameClicked()">
        <mat-icon>cancel</mat-icon>
      </button>
    </h3>
  </div>

  <div edit-container>
    <filter-profile-settings
      #filterProfileSettings
      [currentFilterProfile]="currentEditingFilterProfile"
      (onFilterProfileSaved)="onFilterProfileSaved($event)"
    ></filter-profile-settings>
  </div>

  <div
    filters-container
    class="d-flex flex-column align-items-center justify-content-center h-100 w-100"
  >
    <span class="text-center" style="text-wrap-mode: wrap">{{
      'FilterProfile.NoFilterSelectedToEdit' | translate
    }}</span>
  </div>

  <div
    no-profiles-container
    class="d-flex flex-column align-items-center justify-content-center h-100 w-100"
  >
    <span class="text-center" style="text-wrap-mode: wrap">{{
      'FilterProfile.NoFilterProfiles' | translate
    }}</span>
  </div>
</app-profile-settings-tab-display>
